import Button from "components/shared/Button";
import { Icon } from "@wdpr/groot-components";
import { Context } from "Context";
import { useContext } from "react";

const handleBackButtonClick = (event) => {
	event?.preventDefault();
	document?.dispatchEvent(
		new CustomEvent("navigationBackButton", {
			detail: {
				clicked: true,
			},
		})
	);
};

const BackButton = ({ isMobileView }) => {
	const {
		headerData: { backButton },
		cdnAssetsUrl,
	} = useContext(Context);

	if (!backButton) return null;

	return (
		<Button
			analyticsLinkId={backButton.link?.analyticsLinkId}
			onClick={handleBackButtonClick}
			className="syndicated-navigation__nav__back-button"
		>
			<Icon icon={backButton.icon} cdnUrl={cdnAssetsUrl} />
			{isMobileView ? "" : backButton.link?.title}
		</Button>
	);
};

export default BackButton;
